export enum Race {
	BRANCA = 1,
	PRETA = 2,
	PARDA = 3,
	AMARELO = 4,
	INDIGENA = 5,
	CABOCLO = 6,
	MAMELUCO = 7,
	CAFUZO = 8,
	"NÃO SEI" = 99,
}
